import { jsPDF } from "jspdf";
import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";
import { getAdjustedPrice } from "../../../Services/Api";
// import image1 from "../../../Assets/1.webp"

const now = new Date();
const timestamp = now
  .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
  .replace(/[:.]/g, '-')   // Replace colon and dot with dash
  .replace('T', '_')       // Replace 'T' with underscore
  .split('Z')[0];          // Remove trailing 'Z'



export const generatePDFOpt4_TwoCols_2 = (sectionsData, bannerImg) => {

    console.log(sectionsData,"sectionss");

    const pageWidth = 1632;
    const pageHeight = 1056;

    const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [pageWidth, pageHeight],
    });

    const sectionWidth = pageWidth / 4;
    const sectionHeight = pageHeight / 2;
    const bannerImgHeight = 80;
    const maxSectionsPerPage = 8;

    let currentSection = 0;

    while (currentSection < sectionsData.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsData.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const section = sectionsData[sectionIndex];
            console.log(section,"each sec")
            if (!section) continue;

            const col = i % 4;
            const row = Math.floor(i / 4);
            const xPos = col * sectionWidth;
            const yPos = row * sectionHeight;

            const productImageUrl = section.image;
            const name = section.name || "";
            const sku = "Model#" + (section.sku || "");
             const variation = section.variations?.[0]
            const sale_price = variation?.sale_price || 0;
            const was_price = variation?.regular_price || 0;
           

            // Banner
            const bannerImgWidth = sectionWidth - 5;
            doc.addImage(bannerImg, "JPEG", xPos + 2.5, yPos, bannerImgWidth, bannerImgHeight);

            // Main Image
            const imgY = yPos + bannerImgHeight + 5;
            const imgHeight = sectionHeight * 0.65; // reduced so bottom boxes fit
            if (productImageUrl) {
                doc.addImage(productImageUrl, "JPEG", xPos + 5, imgY, sectionWidth - 10, imgHeight);
            }

            // Overlay Name & SKU (top-right of image)
            doc.setFont("Montserrat-Bold", "bold");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            doc.text(name, xPos + sectionWidth - 8, imgY + 14, { align: "right" });

            doc.setFontSize(8);
            doc.setFont("helvetica", "normal");
            doc.text(sku, xPos + sectionWidth - 8, imgY + 24, { align: "right" });

            // Bottom Container
            const bottomBoxY = imgY + imgHeight + 5;
            const bottomBoxHeight = sectionHeight - (bottomBoxY - yPos) - 5;
            const bottomBoxWidth = sectionWidth - 10;
            const bottomBoxX = xPos + 5;

            // Gap between two halves
            const gap = 6;
            const availableWidth = bottomBoxWidth - gap;
            const halfWidth = availableWidth / 2;

            // LEFT half border
            doc.setLineWidth(2);
            doc.setDrawColor(71, 74, 119);
            doc.rect(bottomBoxX, bottomBoxY, halfWidth, bottomBoxHeight, "S");

            // RIGHT half border
            const rightBoxX = bottomBoxX + halfWidth + gap;
            doc.rect(rightBoxX, bottomBoxY, halfWidth, bottomBoxHeight, "S");

            // LEFT content center
            const leftCenterX = bottomBoxX + (halfWidth / 2);
            const leftCenterY = bottomBoxY + (bottomBoxHeight / 2);

            // LEFT content: "Was" + Big Price
            const text2 = "was $" + was_price;
            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(16);
            const text2Width = doc.getTextWidth(text2);
            doc.text(text2, leftCenterX - (text2Width / 2), leftCenterY - 15);

            const text3 = "$" + sale_price;
            doc.setFont("Montserrat-Black", "normal");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(50);
            const text3Width = doc.getTextWidth(text3);
            doc.text(text3, leftCenterX - (text3Width / 2), leftCenterY + 30);

            // RIGHT content center
            const rightCenterX = rightBoxX + (halfWidth / 2);
            let currentY = bottomBoxY + 25;

            const text1_main = "$" + getAdjustedPrice((sale_price!==0 && sale_price!=="")? sale_price : was_price).toString();
            const text1_suffix = "/week";

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setFontSize(20);
            const width_main = doc.getTextWidth(text1_main);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            const width_suffix = doc.getTextWidth(text1_suffix);

            const totalWidth = width_main + width_suffix + 2;
            const combinedTextX = rightCenterX - (totalWidth / 2);

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(20);
            doc.text(text1_main, combinedTextX-5, currentY);

            doc.setFont("helvetica", "bold");
            doc.setTextColor(61, 124, 157);
            doc.setFontSize(18);
            doc.text(text1_suffix, combinedTextX + width_main + 2, currentY);

            // Details under it — split into two lines
            currentY += 12;
            doc.setFont("helvetica", "normal");
            doc.setTextColor(151, 68, 131);
            doc.setFontSize(10);
            doc.text(
                ["Subject to approval.", "Some restrictions apply"],
                rightCenterX,
                currentY,
                { align: "center" }
            );

            // Adjust spacing after 2-line text
            currentY += 28;
            doc.setFont("helvetica", "bold");
            doc.setTextColor(136, 194, 87);
            doc.setFontSize(14);
            doc.text("NO CREDIT 0 DOWN", rightCenterX, currentY, { align: "center" });

            currentY += 18;
            doc.setFont("helvetica", "bold");
            doc.setTextColor(56, 112, 151);
            doc.setFontSize(14);
            doc.text("100 DAYS NO INTEREST", rightCenterX, currentY, { align: "center" });

// Draw dashed lines (horizontal & vertical)
doc.setLineWidth(1);
doc.setDrawColor(0, 0, 0);
doc.setLineDashPattern([5, 3], 0);

// ---------------------------
// HORIZONTAL LINE (between row 0 & row 1)
// ---------------------------
if (row === 0) {
    const yDash = yPos + sectionHeight;
    doc.line(
        0,          // full page width start
        yDash, 
        pageWidth,  // full page width end
        yDash
    );
}

// ---------------------------
// VERTICAL LINES (between 4 columns → 3 lines)
// ---------------------------
const xDashPositions = [
    sectionWidth,          // after col 1
    sectionWidth * 2,      // after col 2
    sectionWidth * 3       // after col 3
];

xDashPositions.forEach((x) => {
    doc.line(
        x,
        0,             // start top
        x,
        pageHeight     // end bottom
    );
});

// Reset dash
doc.setLineDashPattern([], 0);


        }

        currentSection += sectionsOnThisPage;
    }

      doc.save(`price-tags_${timestamp}.pdf`);
};
